var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prompt',{attrs:{"title":_vm.$t(`title`),"label":_vm.$t(`pleaseEntertaxId`),"defaultValue":_vm.taxId,"inputType":"number","placeholder":"ex. 13572468","validator":_vm.validator},on:{"confirm":v => _vm.setOrderParams({ taxId: v })}})
}
var staticRenderFns = []

export { render, staticRenderFns }